<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ data?.title || t('errors.session.expiredTitle') }}</h2>

  <mat-dialog-content>
    <p>{{ data?.message || t('errors.session.expiredMessage') }}</p>

    <!-- Solo mostrar countdown si no es notificación de logout -->
    <p *ngIf="!isLogoutNotification">
      {{ t('errors.session.closingIn', { seconds: timeLeft }) }}
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <!-- Botones para modal de inactividad/renovación -->
    <ng-container *ngIf="!isLogoutNotification">
      <button mat-button [mat-dialog-close]="false">{{ t('errors.session.logout') }}</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ t('errors.session.renew') }}</button>
    </ng-container>

    <!-- Botón para notificación de logout -->
    <ng-container *ngIf="isLogoutNotification">
      <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ t('common.accept') }}</button>
    </ng-container>
  </mat-dialog-actions>
</ng-container>
